import { Controller } from "@hotwired/stimulus"

// Hides the time half of the date fields when an appointment is marked "ganztägig".
//
// Replaces datetimepicker#toggleAltFormat, which rebuilt both flatpickr instances with a
// different display format. The time inputs are plain fields now, so there is nothing to
// reformat — they are simply shown or hidden. Their values stay put, so unticking the box
// brings the previous times back.
export default class extends Controller {
  connect() {
    this.apply()
  }

  toggle() {
    this.apply()
  }

  apply() {
    const allDay = this.element.querySelector('input[type="checkbox"][name*="all_day"]')?.checked
    for (const input of this.element.querySelectorAll('[data-date-picker-target="time"]')) {
      input.classList.toggle("hidden", Boolean(allDay))
    }
  }
}
